import { useTexts } from 'utils/useTexts';
import LoanSelection from '@components/LenderInformation/LoanSelection';
import Footer from '@components/shared/Footer/Footer';

const LoanSelectionPage = () => {
  const { t } = useTexts();
  return (
    <>
      <LoanSelection />
      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default LoanSelectionPage;
